export default __webpack_public_path__ + "static/media/logo.988a9751.png";